import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type RHFTextFieldProps = Omit<
  TextFieldProps,
  'name' | 'value' | 'onChange' | 'onBlur' | 'error'
> & {
  name: string;
};

// RHF-aware MUI TextField. Reads `control` from the surrounding <Form> context (no
// `control` prop needed). Validation messages from Zod that look like i18n keys
// (e.g. `auth.errors.email_invalid`) are translated at render time; literal strings
// fall through unchanged via i18next's `defaultValue`.
export function RHFTextField({ name, helperText, ...rest }: RHFTextFieldProps) {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const errorMsg = fieldState.error?.message;
        return (
          <TextField
            {...rest}
            {...field}
            fullWidth
            error={Boolean(fieldState.error)}
            helperText={errorMsg ? t(errorMsg, { defaultValue: errorMsg }) : helperText}
          />
        );
      }}
    />
  );
}
